// extracted by mini-css-extract-plugin
module.exports = {"header":"SearchBlock_header__2vHiK"};